/** Firebase may take seconds to reject after the user closes the OAuth popup. */
export const GOOGLE_POPUP_FOCUS_RESET_MS = 300;

/**
 * Resets OAuth button loading when the user closes the Google popup before Firebase rejects.
 * Returns cleanup + flow guards so stale promises cannot clear a newer attempt.
 */
export function beginGooglePopupFlow(flowIdRef, onFocusReturn) {
  const flowId = Symbol('google-popup-auth');
  flowIdRef.current = flowId;

  let focusTimer = null;
  const onWindowFocus = () => {
    if (focusTimer) window.clearTimeout(focusTimer);
    focusTimer = window.setTimeout(() => {
      if (flowIdRef.current !== flowId) return;
      onFocusReturn();
    }, GOOGLE_POPUP_FOCUS_RESET_MS);
  };

  window.addEventListener('focus', onWindowFocus);

  const endGooglePopupFlow = () => {
    window.removeEventListener('focus', onWindowFocus);
    if (focusTimer) window.clearTimeout(focusTimer);
    if (flowIdRef.current === flowId) {
      flowIdRef.current = null;
    }
  };

  const isActiveFlow = () =>
    flowIdRef.current === flowId || flowIdRef.current === null;

  return { endGooglePopupFlow, isActiveFlow };
}
